export const display = {
  title: 'Display',
  titleEN: 'Display',
  description: 'Mackolik.com\'da APP ve Web sitesinde bulunan banner ve içerik sayfalarında bulunan banner çalışmalarıdır.',
  descriptionEN: 'Banner and content pages found on the APP and Web sites of Mackolik.com.',
  tabs: [
    {
      id: 1,
      title: 'Pre-roll',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Pre-roll',
          image: 'https://srv-cdn.onedio.com/store/b81346cf637becc49c7a2abf6cd6e66cc5442a622ec64c2d5768215e60821472.png',
          modal: 'video',
          video: 'https://proj-assets.onedio.com/sunum/mackolik/pre-roll-1.mp4',
          modalTitle: 'Pre-roll'
        }
      ]
    },
    {
      id: 2,
      title: 'Pageskin',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          category: 'Gilette Pageskin',
          image: 'https://srv-cdn.onedio.com/store/cc1200921ee804895dda0262f7fa24e22a05fde1bbfc7e8ccbae65e28fb18bcf.png',
          modal: 'image',
          modalTitle: 'Gilette Pageskin'
        },
        // {
        //   id: 2,
        //   category: 'Little Ceasars Pizza',
        //   image: 'https://srv-cdn.onedio.com/store/aa43cd2b84629e116bd8d2edc9a0f4021b74322f8b267c72a15430ac0bdf94d6.png',
        //   modal: 'image',
        //   modalTitle: 'Little Ceasars Pizza'
        // }
      ]
    },
    {
      id: 3,
      title: 'Advertorial',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Advertorial',
          image: 'https://srv-cdn.onedio.com/store/fdaa0716416e48dfc2f217dd40ad7355277580a46e8833c529b400d4105a35f7.png',
          modal: 'image',
          modalTitle: 'Advertorial',
        },
        {
          id: 2,
          name: 'Slider',
          image: 'https://srv-cdn.onedio.com/store/1620b5e00dfb56b19bd651e70427215314e598baeda8395186bf2ff27fc221ad.png',
          modal: 'image',
          modalTitle: 'Slider',
        }
      ]
    },
    {
      id: 4,
      title: 'Masthead',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          category: 'Masthead',
          image: 'https://srv-cdn.onedio.com/store/efb215bf94648f6e60b26aec022c583c5a00dc15ca3e83fbce6eecd729b9d85b.png',
          modal: 'image',
          modalTitle: 'Masthead',
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Pre-roll',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Pre-roll',
          image: 'https://srv-cdn.onedio.com/store/b81346cf637becc49c7a2abf6cd6e66cc5442a622ec64c2d5768215e60821472.png',
          modal: 'video',
          video: 'https://proj-assets.onedio.com/sunum/mackolik/pre-roll-1.mp4',
          modalTitle: 'Pre-roll'
        }
      ]
    },
    {
      id: 2,
      title: 'Pageskin',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          category: 'Gilette Pageskin',
          image: 'https://srv-cdn.onedio.com/store/cc1200921ee804895dda0262f7fa24e22a05fde1bbfc7e8ccbae65e28fb18bcf.png',
          modal: 'image',
          modalTitle: 'Gilette Pageskin'
        },
        // {
        //   id: 2,
        //   category: 'Little Ceasars Pizza',
        //   image: 'https://srv-cdn.onedio.com/store/aa43cd2b84629e116bd8d2edc9a0f4021b74322f8b267c72a15430ac0bdf94d6.png',
        //   modal: 'image',
        //   modalTitle: 'Little Ceasars Pizza'
        // }
      ]
    },
    {
      id: 3,
      title: 'Advertorial',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Advertorial',
          image: 'https://srv-cdn.onedio.com/store/fdaa0716416e48dfc2f217dd40ad7355277580a46e8833c529b400d4105a35f7.png',
          modal: 'image',
          modalTitle: 'Advertorial',
        },
        {
          id: 2,
          name: 'Slider',
          image: 'https://srv-cdn.onedio.com/store/1620b5e00dfb56b19bd651e70427215314e598baeda8395186bf2ff27fc221ad.png',
          modal: 'image',
          modalTitle: 'Slider',
        }
      ]
    },
    {
      id: 4,
      title: 'Masthead',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          category: 'Masthead',
          image: 'https://srv-cdn.onedio.com/store/efb215bf94648f6e60b26aec022c583c5a00dc15ca3e83fbce6eecd729b9d85b.png',
          modal: 'image',
          modalTitle: 'Masthead',
        }
      ]
    }
  ]
}
